export default __webpack_public_path__ + "static/media/longchamp12.78b22aa7.jpg";